<template>
    <div class="asistencia-dialog">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">Totales de asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-container fluid grid-list-xl>
                                <v-layout align-center wrap>
                                    <v-flex tag="strong" sm7 text-xs-right mr-2>Total de registros:</v-flex>
                                    <v-flex sm4>{{
                                        initialItem.asistencia_totales.total_registros
                                            ? initialItem.asistencia_totales.total_registros
                                            : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm7 text-xs-right mr-2>Total de ausencias:</v-flex>
                                    <v-flex sm4>{{
                                        initialItem.asistencia_totales.total_ausencias
                                            ? initialItem.asistencia_totales.total_ausencias
                                            : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm7 text-xs-right mr-2>Ausencias justificadas:</v-flex>
                                    <v-flex sm4>{{
                                        initialItem.asistencia_totales.ausencias_justificadas
                                            ? initialItem.asistencia_totales.ausencias_justificadas
                                            : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm7 text-xs-right mr-2>Ausencias injustificadas:</v-flex>
                                    <v-flex sm4>{{
                                        initialItem.asistencia_totales.ausencias_injustificadas
                                            ? initialItem.asistencia_totales.ausencias_injustificadas
                                            : "-"
                                    }}</v-flex>
                                    <v-flex tag="strong" sm7 text-xs-right mr-2>Tiempo de retraso:</v-flex>
                                    <v-flex sm4>{{
                                        initialItem.asistencia_totales.tiempo_retraso
                                            ? initialItem.asistencia_totales.tiempo_retraso
                                            : "-"
                                    }}</v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey lighten-3" @click="loadAsistencia" :loading="loading"
                                >Ver detalles</v-btn
                            >
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Ok</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <asistencia-time-line
            v-if="showAsistenciaTimeLine"
            @formCanceled="showAsistenciaTimeLine = false"
            :data="timeLineData"
        ></asistencia-time-line>
    </div>
</template>

<script>
const AsistenciaTimeLine = () =>
    import(/* webpackChunkName: "asistencia-time-line" */ "@/components/widgets/asistencia-time-line/asistencia-time-line")
export default {
    components: { AsistenciaTimeLine },
    props: {
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,

            //asistencia time line
            showAsistenciaTimeLine: false,
            timeLineData: []
        }
    },
    computed: {
        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        }
    },

    methods: {
        cancelForm() {
            this.$emit("formCanceled")
        },

        loadAsistencia() {
            this.loading = true

            this.$store.commit("SET_EMPLEADO_ASISTENCIAS_PAG", { page: 1 })
            let empleado = this.$store.getters.EMPLEADO_ASISTENCIAS
            if (!empleado || empleado.id !== this.initialItem.id) {
                //si no se ha cargado la asistencia del empleado solicitado
                this.$store.dispatch("LOAD_EMPLEADO_ASISTENCIA", { empleado_id: this.initialItem.id }).then(() => {
                    if (
                        this.$store.getters.EMPLEADO_ASISTENCIAS.id === this.initialItem.id &&
                        this.$store.getters.EMPLEADO_ASISTENCIAS.asistencia
                    ) {
                        this.timeLineData = {
                            ...this.$store.getters.EMPLEADO_ASISTENCIAS,
                            nombre: this.initialItem.nombre,
                            apellido_paterno: this.initialItem.apellido_paterno,
                            apellido_materno: this.initialItem.apellido_materno
                        }
                        this.showAsistenciaTimeLine = true
                        this.loading = false
                    }
                })
            } else {
                this.loading = false
                this.showAsistenciaTimeLine = true
            }
        }
    }
}
</script>
